
//Libraries
import { computed, defineComponent, onMounted, ref } from "vue";

//Types
import { TabOptionsConfig } from "@/shared/types/config/tab-options-config";

//Config
import { filters } from "./config/filters";

//Services
import { determinePcScreen } from "../../shared/services/screen-service";

//Components
import NavBar from "../../shared/components/Nav.vue";
import Filters from "../../shared/components/TabOptions.vue";
import ShopGame from "../../shared/components/game/ShopGame.vue";
import RightBar from "./RightBarContent.vue";
import LoadingBar from "../../shared/components/LoadingBar.vue";

export default defineComponent({
  name: "ShopModule",
  components: {
    NavBar,
    Filters,
    ShopGame,
    RightBar,
    LoadingBar,
  },
  setup() {
    //Data

    const filterOptions: TabOptionsConfig = filters;

    const isLoading = ref<boolean>(true);
    const isSearchFilter = ref<boolean>(false);

    const currentFilter = ref<string>(filters.currentOption.name);
    const search = ref<string>("");

    //Methods

    const getData = () => {
      isLoading.value = true;
      setData();
    };

    const searchData = () => {
      if (search.value != "") {
        isSearchFilter.value = true;
        isLoading.value = true;

        setData();
      }
    };

    const setData = () => {
      setTimeout(() => {
        isLoading.value = false;
      }, 500);
    };

    const setFilter = (value: string) => {
      currentFilter.value = value;
      isSearchFilter.value = false;
      search.value = "";

      getData();
    };

    //Computed

    const isPcScreen = computed<boolean>(() => {
      return determinePcScreen();
    });

    //Lifecycle Hooks

    window.scrollTo(0, 0);

    onMounted(() => {
      getData();
    });

    return {
      //Data
      isLoading,
      filterOptions,
      search,
      //methods
      setFilter,
      searchData,
      //Computed
      isPcScreen,
    };
  },
});
